import { useState, useEffect } from 'react';
import { renderQuestions } from 'src/components/helpers/renderFormQuestions';
import { QuizContainer, QuizSection } from '../styles/QuizStyles';
import { Message, Icon } from 'semantic-ui-react';
import { prestadores_evaluacion_questions } from './quiz/prestadores_evaluacion_questions';
import intranetServiceInstance from 'src/services/api/intranetService';
import Toast from 'src/components/toast';
import { errorInput } from 'src/components/helpers';
import { crecimiento_directores_evaluacion_questions } from './quiz/crecimiento_directores_evaluacion_questions';

const Quiz = ({ entry, interactions, currentUserId, onMarkAsRead, fetchInteractions }) => {
  const [inputs, setInputs] = useState({});
  const [errorInputs, setErrorInputs] = useState({});
  const [dateFocused, set_dateFocused] = useState(null);
  const [saving, setSaving] = useState(false);

  const quizSubmission = interactions.find(
    (interaction) =>
      interaction.content?.entryId === entry.id &&
      interaction.type === 'quiz' &&
      interaction.user_id === currentUserId
  );

  let questions = [];
  if (entry.content === 'prestadores_evaluacion') {
    questions = prestadores_evaluacion_questions(inputs);
  } else if (entry.content === 'crecimiento_directores_evaluacion') {
    questions = crecimiento_directores_evaluacion_questions(inputs);
  }

  const verifyForm = () => {
    let errorInputs = {};

    let mandatoryInputs = Object.values(questions)
      ?.filter((a) => !!a.id && !a?.notMandatory)
      ?.map((a) => a.id);

    mandatoryInputs.forEach((input) => {
      errorInputs = errorInput({
        errorInputs,
        input: { name: input, value: inputs?.[input] },
      });
    });

    setErrorInputs(errorInputs);
    return Object.values(errorInputs).includes(true);
  };

  const sendForm = async () => {
    if (verifyForm()) return;
    setSaving(true);

    try {
      const content = {
        entryId: entry.id,
        entryContent: entry.content,
        answers: inputs,
      };

      await intranetServiceInstance.createInteraction({
        type: 'quiz',
        content,
      });

      localStorage.removeItem(`quiz_${entry.id}`);
      setInputs({});

      // Mark entry as read after successful submission
      if (onMarkAsRead) {
        await onMarkAsRead(entry);
      }

      // Refetch interactions to update the UI
      if (fetchInteractions) {
        await fetchInteractions();
      }

      Toast.fire({
        icon: 'success',
        title: 'Respuestas guardadas correctamente',
      });
    } catch (error) {
      console.error('Error saving quiz to backend:', error);
      Toast.fire({
        icon: 'error',
        title: 'Error',
        text: 'Error al guardar las respuestas.',
      });
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    if (Object.keys(inputs).length > 0) {
      localStorage.setItem(`quiz_${entry.id}`, JSON.stringify(inputs));
    }
  }, [inputs, entry.id]);

  const handleInputs = (event) => {
    const { name, value } = event.target;
    setInputs({ ...inputs, [name]: value });
    setErrorInputs((prev) => ({ ...prev, [name]: false }));
  };

  useEffect(() => {
    const savedAnswers = localStorage.getItem(`quiz_${entry.id}`);
    if (savedAnswers) {
      try {
        const parsedAnswers = JSON.parse(savedAnswers);
        setInputs(parsedAnswers);
      } catch (error) {
        localStorage.removeItem(`quiz_${entry.id}`);
      }
    }
  }, [entry.id]);

  if (quizSubmission)
    return (
      <Message success>
        <Icon name="check circle" />
        <Message.Content>
          <Message.Header>Encuesta completada</Message.Header>
          <p>Gracias por tu participación.</p>
        </Message.Content>
      </Message>
    );

  return (
    <QuizContainer>
      <Message info>
        <Icon name="info circle" />
        <Message.Content>
          <Message.Header>Respuestas guardadas automáticamente</Message.Header>
          <p>
            Tus respuestas se guardan automáticamente mientras completas la encuesta. Puedes volver
            más tarde para continuar.
          </p>
        </Message.Content>
      </Message>

      <QuizSection>
        {renderQuestions({
          questions,
          inputs,
          handleInputs,
          errorInputs,
          sending: saving,
          sendForm,
          dateFocused,
          set_dateFocused,
        })}
      </QuizSection>
    </QuizContainer>
  );
};

export default Quiz;
